// Reports Module - Root Sagas
// This file aggregates all reports-related sagas

import watchReportsListSaga from './List/store/saga'
import watchReportFormSaga from './Form/store/saga'
import watchFormTypesListSaga from './FormTypes/store/saga'

// Root saga for Reports module
export default [
  watchReportsListSaga(),
  watchReportFormSaga(),
  watchFormTypesListSaga(),
]

